import compose from "ramda/src/compose"
import map from "ramda/src/map"
import prop from "ramda/src/prop"
import groupBy from "ramda/src/groupBy"
import uniqBy from "ramda/src/uniqBy"
import flatten from "ramda/src/flatten"
import evolve from "ramda/src/evolve"
import path from "ramda/src/path"
import uniq from "ramda/src/uniq"

/**
 * Создает для стака id (записываея в uuid) на основе
 * однозначно характеризующих стак параметров
 */
const makeIdsForStacks = records => {
  const makeStackId = (stack, resource) =>
    `stack_${resource.uuid}_${stack.startDateTime}_${stack.startDateTime}_${stack.count}`

  return records.map(record => ({
    ...record,
    items: record.items.map(item =>
      item.eventsStack
        ? { ...item, uuid: makeStackId(item, record.resource) }
        : item,
    ),
  }))
}

export const updateEventMap = (records, eventMap) => {
  const makeEventMap = compose(
    map(prop(0)),
    groupBy(prop(`uuid`)),
    uniqBy(prop(`uuid`)),
    flatten,
    map(prop(`items`)),
    makeIdsForStacks,
  )

  return {
    ...eventMap,
    ...makeEventMap(records),
  }
}

export const updateResourceMap = (records, resourceMap) => {
  const makeResourceMap = compose(
    map(prop(0)),
    groupBy(prop(`uuid`)),
    map(prop(`resource`)),
  )

  return {
    ...resourceMap,
    ...makeResourceMap(records),
  }
}

export const updateRecordMap = (records, recordMap) => {
  const makeRecordsMap = compose(
    map(prop(0)),
    groupBy(prop(`resource`)),
    map(evolve({ resource: prop(`uuid`), items: map(prop(`uuid`)) })),
    makeIdsForStacks,
  )

  return {
    ...recordMap,
    ...makeRecordsMap(records),
  }
}

export const updateDataList = (records, dataList) => {
  const makeList = map(path([`resource`, `uuid`]))

  return uniq([...dataList, ...makeList(records)])
}
